/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component, createRef } from 'react';
import { OverlayTrigger, Tooltip, Form, Button, Modal } from 'react-bootstrap';
import Axios from 'axios';
// project imports
import { getSellerUrl, getSellerHeaders, getBuyerUrl, getBuyerHeaders } from 'shared/http';
import toast from 'shared/toast';
import Excel from 'assets/CSV.svg'
// style imports
import './Datatable.scss';

import { CSVLink } from "react-csv";
import { Link } from 'react-router-dom';
import { REFRESH_TOKEN, isTokenExpiredBeforeOneHour, getToken } from 'shared/settings/token';
import { MAX_LIMIT } from 'shared/settings/config';
import store from 'features/store';
// import { passwordreset } from 'shared/settings/apiconfig';
/**
 * generic table to render provided data in tabular format
 * 
 * @param config
 * 
 * @returns html code to rener table on specified api data
 * 
**/

export class Datatable extends Component {

    allRows;
    field;
    actionRefs;
    tableDataRef;
    tooltipTextIndex;
    createButton = ['sale', 'item', 'user','invoice'];

    constructor(props) {
        super(props);

        this.state = {
            // user defined properties
            fromName: props.config.name,
            pagination: props.config.pagination,
            sort: props.config.sort,
            search: props.search ? props.search : [],
            searchData: props.search ? props.search.searchData : false,
            accordion: {
                display: Object.keys(props.config.columns[props.config.columns.length - 1]).includes('actions') && props.config.columns[props.config.columns.length - 1]['actions'].includes('accordion'),
                rowId: -1
            },
            extraButton: props.config.extraButton ? props.config.extraButton : null,

            // contains data for each row
            rows: [],

            // table pagination details
            size: 10,
            totalRows: null,
            page: 1,
            maxPage: 1,
            next: null,
            previous: null,
            paginationState: {}, // this will have previous pagination details

            // loading
            tableLoading: false,
            allItemsSelected: false,

            //tooltip
            showTooltip: false,
            tooltipText: '',
            csvColumn: [],
            csvRow: [],
            totalCount: 0,
            modal: false,
            filteredData: [],
            MaxLimitModal: false,
            PageSize: 10,
            itemreportPayload: []
        };

        if (this.props.location && this.props.location.state && this.props.location.state.datatable) {
            let temp = {};
            if (this.props.location.state.datatable.next) {
                temp['next'] = this.props.location.state.datatable.next;
            } else if (this.props.location.state.datatable.previous) {
                temp['previous'] = this.props.location.state.datatable.previous;
            }

            if (this.props.location.state.datatable.sort) {
                temp['sort'] = this.props.location.state.datatable.sort;
            }

            if (this.props.location.state.datatable.search) {
                temp['search'] = this.props.location.state.datatable.search;
            }

            temp['page'] = this.props.location.state.datatable.page ? this.props.location.state.datatable.page : 1;
            temp['totalRows'] = this.props.location.state.datatable.totalRows ? this.props.location.state.datatable.totalRows : null;
            temp['maxPage'] = this.props.location.state.datatable.maxPage ? this.props.location.state.datatable.maxPage : 1;
            temp['size'] = this.props.location.state.datatable.size ? this.props.location.state.datatable.size : 10;
            this.state = {
                ...this.state,
                ...temp
            };
        }

        this.allRows = [];
        this.adminData = [];
        this.field = props.config.field ? props.config.field : [];
        this.actionRefs = {
            clone: createRef(),
            notes: createRef(),
            dashboard: createRef(),
            view: createRef(),
            edit: createRef(),
            delete: createRef(),
            flag: createRef()
        };
        this.tableDataRef = createRef();
        this.tooltipTextIndex = '';
    }

    componentDidMount() {
        //Handle Pagination Dropdown
        if (this.props?.location?.state) {
            if (this.props?.location?.state?.PageSize) {
                this.setState({
                    PageSize: this.props.location?.state?.PageSize
                })
            }
            else {
                this.setState({
                    PageSize: 10
                })
            }
        }
        else {
            this.setState({
                PageSize: 10
            })
        }

        var csvColumnList = this.props.config.filename === 'item-report' ? '' : this.props.config.columns
        if ("csvColumn" in this.props.config) {
            csvColumnList = [...csvColumnList, ...this.props.config.csvColumn]
        }
        let csvColumn = csvColumnList.map((col, index) => {
            if (col["name"] !== '') {
                return ({
                    id: col["property"],
                    displayName: col["name"],
                    customType: col["columnType"] === "custom",
                    customValue: col["customColumn"]
                })
            }
            else {
                return {}
            }
        })
        csvColumn = csvColumn.filter(value => Object.keys(value).length !== 0);
        this.setState({
            csvColumn,
        })
        this.state.search && this.state.search.searchData ? this.searchData(this.state.next ? 1 : this.state.previous ? -1 : null) :
            this.getTableData(this.state.next ? 1 : this.state.previous ? -1 : null);
    }

    // componentDidUpdate(prevProps) {
    //     if ((prevProps.buyerHeaders && this.props.buyerHeaders && prevProps.buyerHeaders !== this.props.buyerHeaders) ||
    //         (prevProps.itemStatusChanged !== this.props.itemStatusChanged))
    //         this.getTableData();
    // }

    // componentDidUpdate(prevProps, prevState) {
    //     let filterSearch = [];
    //     if (prevProps.search !== this.props.search) {
    //         if (this.props.search && this.props.search.searchData) {
    //             for (let key of Object.keys(this.props.search.search)) {

    //             }
    //         }
    //         this.setState({
    //             ...this.state,
    //             search: filterSearch,
    //             page: 1,
    //             next: null,
    //             previous: null,
    //             sort: this.props.config.sort
    //         }, () => this.getTableData());
    //     }
    // }
    selectAllCheckBoxsale = () => {
        return (
            // <><div><Form><Form.Check className="custom-header-checkbox" type="checkbox" onChange={(event) => { this.allItemsSelect(event) }} checked={this.state.allItemsSelected} /></Form></div></>
            <Form>
                {/* <Form.Check type="checkbox" label="" value={value.id} onChange={(event) => { event.stopPropagation(); this.selectItems(event, value) }} /> */}
                <div className={`custom-checkbox-div ${this.state.allItemsSelected ? 'checked' : ''} white-bg`} onClick={(event) => { this.allItemsSelect(!this.state.allItemsSelected) }}></div>
            </Form>
        );
    }

    selectAllCheckBox = () => {
        return (
            // <><div><Form><Form.Check className="custom-header-checkbox" type="checkbox" onChange={(event) => { this.allItemsSelect(event) }} checked={this.state.allItemsSelected} /></Form></div></>
            <Form>
                {/* <Form.Check type="checkbox" label="" value={value.id} onChange={(event) => { event.stopPropagation(); this.selectItems(event, value) }} /> */}
                <div className={`custom-checkbox-divnew ${this.state.allItemsSelected ? 'checked' : ''} white-bg`} onClick={(event) => { this.allItemsSelect(!this.state.allItemsSelected) }}></div>
            </Form>
        );
    }


    onclickCSV() {
        this.setState({ tableLoading: true })
        let filterSearch = [];
        const search = this.props.search ? this.props.search.search : {};
        Object.keys(search).forEach(key => {
            if (this.props.search.search[key].value || this.props.search.search[key].value === 0) {
                filterSearch.push(this.props.search.search[key]);
            }
        });
        let fieldSearch = this.state.csvColumn.map((col, key) => col.id).filter((elem)=> {return elem});
        let fieldSales = this.props.config.field
        // other report payload
        var data = {
            sort: this.props.config.name === 'upcoming sales report' ? [{ field: "starttime", direction: "asc" }] : [],
            field: this.props.config.name === 'upcoming sales report' ? fieldSales : fieldSearch,
            filter: filterSearch
        }
        // item report payload
        let { itemreportPayload } = this.state
        const { page, ...restPayload } = itemreportPayload;
        let itemReportfilterValue = restPayload;
        let payload = this.props.config.filename === 'item-report' ? itemReportfilterValue : data
        if ("defaultFilter" in this.props.config && this.props.config.defaultFilter.length > 0) {
            data['filter'] = data['filter'] ? data['filter'] : []
            data['filter'] = [...data['filter'], ...this.props.config.defaultFilter]
        }
        // Max limit set true if the response length is 5000
        if (this.state.MaxLimitModal) {
            this.setState({
                modal: true,
                tableLoading: false
            })
        }
        else {
            Axios.post(getSellerUrl(this.props.config.url, this.props.config.params, this.props.config.isReport ? true : false), JSON.stringify(payload), getSellerHeaders())
                .then((response) => {
                    if (this.props.config.name === 'admin report') {
                        this.adminData = [response.data['data']];
                    }
                    else if (this.props.config.name === 'seller report') {
                        this.adminData = response.data['message'] ? response.data['message'] : [];
                    }
                    else {
                        this.adminData = response.data['data'];
                    }
                    if (this.adminData.length > 0) {
                        let csvRow = ""
                        let csvHeader = ""
                        if (this.props.config.name === 'sale active report' || this.props.config.name === 'sale history report') {
                            let reportColumn = this.state.csvColumn.filter((col, key) => {
                                return col.id != 'saleid'
                            })
                            this.setState({
                                filteredData: reportColumn
                            })
                        }
                        else {
                            this.setState({
                                filteredData: this.state.csvColumn
                            })
                        }
                        this.adminData.map((item, index) => {
                            let csvRowItem = []
                            let csvHeaderItem = []
                            try {
                                this.state.filteredData.map((col, key) => {
                                    csvHeaderItem.push(col["displayName"])
                                    if (col["customType"]) {
                                        let data = col["customValue"](item)
                                        typeof data === 'string' ? csvRowItem.push('"' + data.replace(/"/g, '""') + '"') : csvRowItem.push(data);
                                    }
                                    else { 
                                        typeof item[col["id"]] === 'string' ? csvRowItem.push('"' + item[col["id"]].replace(/"/g, '""') + '"') : csvRowItem.push(item[col["id"]]);   
                                    }
                                })
                                csvRow = csvRow + csvRowItem.join(",") + '\r\n'
                                csvHeader = csvHeaderItem.map(elem => {return '"' + elem + '"' }).join(",") + '\r\n'
                                return item
                            } catch (e) {
                            }
                        })
                        let BOM = "\uFEFF";
                        let csvData = BOM + csvHeader + csvRow
                        const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8' });
                        const url = window.URL.createObjectURL(blob)
                        const a = document.createElement('a')
                        a.setAttribute('href', url)
                        a.setAttribute('download', `${this.props.config.filename}.csv`);
                        a.click()
                        this.setState({
                            tableLoading: false
                        })
                    }
                    else {
                        toast.error("No Data Availabe")
                    }
                })
                .catch((error) => {
                    this.setState({ tableLoading: false });
                    toast.error(error);
                });
        }
    }
    exportCSV = () => {
        return (<>

            <div >
                <Button disabled={!(this.allRows.length > 0)} onClick={() => this.onclickCSV()} className="button-view" style={{ marginLeft: "1%", float: "right" }}>
                    <div className="button-text" >
                        <img src={Excel} width="25px" height="25px" style={{ marginRight: "10px" }} alt="excel" />Export to CSV</div>
                </Button>
            </div>
        </>
        )
    }
    allItemsSelect = (event) => {
        this.props.allItemsSelect(event);
    }
    checkBoxHandle = (value) => {
        this.setState({
            allItemsSelected: value
        });
    }
    searchData = (newPage = null) => {
        let filterSearch = [];
        const search = this.props.search ? this.props.search.search : {};

        Object.keys(search).forEach(key => {
            if (this.props.search.search[key].value || this.props.search.search[key].value === 0) {
                filterSearch.push(this.props.search.search[key]);
            }
        });

        if (!newPage) {
            this.setState({
                search: filterSearch,
                searchData: filterSearch.length ? true : this.props.search && this.props.search.searchData ? this.props.search.searchData : false,
                page: 1,
                next: null,
                previous: null,
                sort: this.state.sort,
                accordion: { ...this.state.accordion, rowId: -1 }
            }, () => this.getTableData(newPage));
        } else {
            this.setState({
                search: filterSearch,
                searchData: filterSearch.length ? true : this.props.search && this.props.search.searchData ? this.props.search.searchData : false,
                page: this.state.page,
                next: this.state.next,
                previous: this.state.previous,
                sort: this.state.sort,
                accordion: { ...this.state.accordion, rowId: -1 }
            }, () => this.getTableData(newPage));
        }
    }

    rowAction = (value, action, event, tableState = false) => { // only required action will pass state true, others wont
        let stateData;  // if no data is available then "undefined" will be set
        event.preventDefault();
        event.stopPropagation();

        // when type is "edit", it sets the current state of datatable
        // current page, filters, sort are set in "datatable" state
        // this state value will be cleared all the time(if available) 
        // when entered to databale page from any other page and will 
        // be set again if "edit" is clicked
        // this state value can be obtained in other pages using "props"
        if (tableState) {
            stateData = this.getTableState();
        }
        action(value, { datatable: stateData });
    };

    // get the current state of table
    getTableState = () => {
        const stateData = {};

        // check next or previous available
        if (Object.keys(this.state.paginationState).length) {
            if (this.state.paginationState.next) {
                stateData['next'] = this.state.paginationState.next;
            } else if (this.state.paginationState.previous) {
                stateData['previous'] = this.state.paginationState.previous;
            }
        }
        if (this.state.paginationState.search) {
            stateData['search'] = this.state.paginationState.search;
        }
        if (this.state.paginationState.size) {
            stateData['size'] = this.state.paginationState.size ? this.state.paginationState.size : 10;
        }
        stateData['sort'] = this.state.paginationState.sort;
        stateData['page'] = this.state.paginationState.page;
        stateData['totalRows'] = this.state.paginationState.totalRows;
        stateData['maxPage'] = this.state.paginationState.maxPage;

        return stateData;
    };

    toggleAccordion = (index, event = null) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (this.state.accordion.rowId !== index && this.props.onOpenAccordion) {
            this.props.onOpenAccordion({ data: this.state.rows[index], index });
        }
        this.setState({
            accordion: {
                display: true,
                rowId: this.state.accordion.rowId === index ? -1 : index
            }
        });
    };

    columnType = (row, column, index) => {
        if (row) {
            switch (column['columnType']) {
                case 'actions':
                    return (
                        <div className="flex-row  justify-content-between">
                            {/* action buttons on left side */}
                            <div className="flex-row action-button-group d-flex align-items-center">
                                {
                                    column['actions'].includes('clone') ?
                                        <OverlayTrigger trigger={window.screen.width > 1400 && "hover"} overlay={<Tooltip id="tooltip-clone">Clone</Tooltip>}>
                                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/clone.svg`} alt="clone" className="action-button" onClick={(event) => this.rowAction(row, column['actionEvents']['clone'], event)} />
                                        </OverlayTrigger> :
                                        null
                                }
                                {
                                    column['actions'].includes('notes') ?
                                        <OverlayTrigger trigger={window.screen.width > 1400 && "hover"} overlay={<Tooltip id="tooltip-notes">Notes</Tooltip>}>
                                            {
                                                this.props.showNotesGreenCircle ?
                                                    <div className="notes-icon-container">
                                                        {
                                                            this.props.config.notesGreenCircle(row) ?
                                                                <div className="green-icons"></div>
                                                                : null
                                                        }
                                                        <img src={`${process.env.PUBLIC_URL}/static/icons/table/notes.svg`} alt="notes" className="action-button" onClick={(event) => this.rowAction(row[column['property']], column['actionEvents']['notes'], event)} />
                                                    </div> :
                                                    <img src={`${process.env.PUBLIC_URL}/static/icons/table/notes.svg`} alt="notes" className="action-button" onClick={(event) => this.rowAction(row[column['property']], column['actionEvents']['notes'], event)} />
                                            }

                                        </OverlayTrigger> :
                                        null
                                }
                                {
                                    column['actions'].includes('dashboard') ?
                                        <OverlayTrigger trigger={window.screen.width > 1400 && "hover"} overlay={<Tooltip id="tooltip-dashboard">Dashboard</Tooltip>}>
                                            <Link
                                                to={{
                                                    pathname:
                                                        this.state.fromName === 'sale' ? `/sales/dashboard/${row['id']}` :
                                                            "",
                                                }}
                                                onClick={(event) => this.rowAction(row, column['actionEvents']['dashboard'], event, true)} >
                                                <img src={`${process.env.PUBLIC_URL}/static/icons/table/dashboard.svg`} alt="dashboard" className="action-button" />
                                            </Link>
                                        </OverlayTrigger> :
                                        null
                                }
                                {
                                    column['actions'].includes('view') ?
                                        <OverlayTrigger trigger={window.screen.width > 1400 && "hover"} delay={{ show: 250, hide: 400 }} overlay={<Tooltip id="tooltip-view">View</Tooltip>}>
                                            {this.state.fromName === 'invoice' ?
                                                <Link to={{ pathname: this.state.fromName === 'invoice' ? row['type'] == 'RA' ? `invoice/ra/view/${row['id']}` : row['type'] == 'DG' ? `invoice/dg/view/${row['id']}` : `invoice/view/${row['id']}` : "" }} >
                                                    <img src={`${process.env.PUBLIC_URL}/static/icons/table/view.svg`} alt="view" className="action-button" onClick={(event) => this.rowAction(row, column['actionEvents']['view'], event)} />
                                                </Link> :
                                                <img src={`${process.env.PUBLIC_URL}/static/icons/table/view.svg`} alt="view" className="action-button" onClick={(event) => this.rowAction(row, column['actionEvents']['view'], event, true)} />
                                            }
                                        </OverlayTrigger> :
                                        null
                                }
                                {
                                    column['actions'].includes('edit') && (column['actionEnableOn'] === undefined || (column['actionEnableOn']['edit'] !== undefined && column['actionEnableOn']['edit'](row))  && (row.pendingamount >= row.invoiceamount) ) ?
                                        <OverlayTrigger trigger={window.screen.width > 1400 && "hover"} overlay={<Tooltip id="tooltip-edit">Edit</Tooltip>}>
                                            <Link
                                                to={{
                                                    pathname: this.state.fromName === 'sale' ? `/sales/edit/${row['id']}` :
                                                        this.state.fromName === 'location' ? `/locations/edit/${row['id']}` :
                                                            this.state.fromName === 'user' ? `/locations/staff-agents/edit/${row['locationid']}/${row['id']}` :
                                                                this.state.fromName === 'location template' ? `/locations/templates/edit/${row['id']}` :
                                                                    this.state.fromName === 'item' ? `/sales/items/edit/${row['id']}` :
                                                                        this.state.fromName === 'buyer' ? `/buyer/edit/${row['id']}` :
                                                                            this.state.fromName === 'invoice' ? `invoice/edit/${row['id']}` :
                                                                                "",
                                                    state: column['actionEvents']['edit']
                                                }}
                                            >
                                                <img src={`${process.env.PUBLIC_URL}/static/icons/table/edit.svg`} alt="edit" className="action-button" onClick={(event) => this.rowAction(row, column['actionEvents']['edit'], event, true)} />
                                            </Link>
                                        </OverlayTrigger> :
                                        null
                                }
                

                                {
                                    column['actions'].includes('delete') ?
                                        <OverlayTrigger trigger={window.screen.width > 1400 && "hover"} overlay={<Tooltip id="tooltip-delete">Delete</Tooltip>}>
                                            <img src={`${process.env.PUBLIC_URL}/static/icons/sidebar/delete.svg`} alt="delete" style={{ height: "19px", width: "19px" }} className="action-button" onClick={(event) => this.rowAction(row, column['actionEvents']['delete'], event, true)} />
                                        </OverlayTrigger> :
                                        null
                                }
                                {
                                    column['actions'].includes('flag') && row.suspensioncount > 0 ?
                                        <OverlayTrigger trigger={window.screen.width > 1400 && "hover"} overlay={<Tooltip id="tooltip-delete">Flag</Tooltip>}>
                                            <img src={`${process.env.PUBLIC_URL}/static/icons/sidebar/flag.png`} alt="flag" style={{ height: "19px", width: "19px" }} className="action-button" onClick={(event) => this.rowAction(row, column['actionEvents']['flag'], event, true)} />
                                        </OverlayTrigger> :
                                        null
                                }
                                {
                                    column['actions'].includes('accordion') ?
                                        (
                                            this.state.accordion.rowId === index ?
                                                <div>
                                                    <i className="fa fa-chevron-down" style={{ color: '#e1e1e1', cursor: 'pointer', marginLeft: '55px' }} onClick={() => this.setState({ accordion: { display: true, rowId: -1 } })}></i>
                                                </div> :
                                                <div>
                                                    <i className="fa fa-chevron-right" style={{ color: '#e1e1e1', cursor: 'pointer', marginLeft: '55px' }} onClick={() => this.toggleAccordion(index)}></i>
                                                </div>
                                        ) :
                                        null
                                }
                            </div>
                        </div>
                    );
                case 'custom':
                    return column['customColumn'](row, column['needState'] ? { datatable: this.getTableState() } : null);
                default:
                    return row[column['property']] ? row[column['property']] : '- - -';
            }
        }
    };

    setRequestData = (newPage) => {
        const data = {
            sort: this.state.sort
        };

        /* get only the specified fields */
        if (this.field.length) {
            data['field'] = this.field;
        }

        /* append if search is made */
        if (this.state.search) {
            data['filter'] = this.state.search;
        }
        if ("defaultFilter" in this.props.config && this.props.config.defaultFilter.length > 0) {
            data['filter'] = data['filter'] ? data['filter'] : []
            data['filter'] = [...data['filter'], ...this.props.config.defaultFilter]
        }

        /* set page size if not set all data will be fetched */
        data['page'] = {
            size: this.state.size
        };
        if (this.state.pagination) {
            if (newPage === 1) {
                data['page']['next'] = this.state.next;
            } else if (newPage === -1) {
                data['page']['previous'] = this.state.previous;
            }
        }

        return data;
    };

    getTableData = (newPage = null) => {
        if (this.state.searchData) {
            const data = this.setRequestData(newPage);
            this.setState({
                itemreportPayload: data
            })

            if (!this.props.isMock) {
                if (this.props.config.url) {
                    this.setState({ tableLoading: true, rows: [] });
                    // let url= this.props.config.url.includes('buyer') ? getBuyerUrl(this.props.config.url, this.props.config.params) : getSellerUrl(this.props.config.url, this.props.config.params);
                    // let headers = this.props.config.url.includes('buyer') ? this.props.buyerHeaders : getSellerHeaders();
                    const checkIsBuyerAPI = this.props.config.buyerUrl;
                    const APIUrl = checkIsBuyerAPI ? getBuyerUrl(this.props.config.url, this.props.config.params) : getSellerUrl(this.props.config.url, this.props.config.params, this.props.config.isReport ? true : false);
                    const ApiHeaders = checkIsBuyerAPI ? checkIsBuyerAPI.token ? getBuyerHeaders(checkIsBuyerAPI.token) : getBuyerHeaders() : getSellerHeaders();
                    Axios.post(APIUrl, JSON.stringify(data), ApiHeaders)
                        .then((response) => {
                            if (this.props.config.name === 'admin report') {
                                this.allRows = [response.data['data']];
                            }
                            else if (this.props.config.name === 'seller report') {
                                this.allRows = response.data['message'] ? response.data['message'] : [];
                            }
                            else {
                                this.allRows = response.data['data'];
                            }
                            const emitData = JSON.parse(JSON.stringify(response.data));
                            if (response.data.hasOwnProperty('page')) {
                                this.setState({
                                    totalCount: response.data['page']['total'],
                                    rows: response.data['data'],
                                    pagination: true,
                                    next: response.data['page'].hasOwnProperty('keyset') && response.data['page']['keyset'].hasOwnProperty('next') ? response.data['page']['keyset']['next'] : '',
                                    previous: response.data['page'].hasOwnProperty('keyset') && response.data['page']['keyset'].hasOwnProperty('previous') ? response.data['page']['keyset']['previous'] : '',
                                    tableLoading: false,
                                    size: response.data['page']['size'] ? response.data['page']['size'] : 10,
                                    paginationState: { page: this.state.page, totalRows: this.state.totalRows, maxPage: this.state.maxPage, sort: this.state.sort, search: this.state.search, size: this.state.size },
                                }, () => {
                                    if (!newPage) {
                                        if (this.state.totalCount) {
                                            if (this.state.totalCount > MAX_LIMIT) {
                                                this.setState({
                                                    MaxLimitModal: this.props.config.filename === 'item-report' ? false : true
                                                })
                                            }
                                            else {
                                                this.setState({
                                                    MaxLimitModal: false
                                                })
                                            }
                                        }
                                        else {
                                            this.setState({
                                                MaxLimitModal: false
                                            })
                                        }
                                    }
                                    if (data['page']) {
                                        if (data['page']['next']) {
                                            this.setState({
                                                paginationState: {
                                                    ...this.state.paginationState,
                                                    next: data['page']['next']
                                                }
                                            });
                                        } else if (data['page']['previous']) {
                                            this.setState({
                                                paginationState: {
                                                    ...this.state.paginationState,
                                                    previous: data['page']['previous']
                                                }
                                            });
                                        }
                                    }
                                });
                            } else {
                                if (this.props.config.name === 'admin report') {
                                    this.setState({
                                        rows: this.allRows,
                                        pagination: false,
                                        next: '',
                                        previous: '',
                                        tableLoading: false,
                                        MaxLimitModal: false,
                                        paginationState: { page: this.state.page, totalRows: this.state.totalRows, maxPage: this.state.maxPage, sort: this.state.sort, search: this.state.search }
                                    });
                                }
                                else if (this.props.config.name === 'seller report') {
                                    this.setState({
                                        rows: this.allRows,
                                        pagination: false,
                                        next: '',
                                        previous: '',
                                        tableLoading: false,
                                        MaxLimitModal: false,
                                        paginationState: { page: this.state.page, totalRows: this.state.totalRows, maxPage: this.state.maxPage, sort: this.state.sort, search: this.state.search }
                                    });
                                }
                                else {
                                    this.setState({
                                        rows: this.allRows.slice(0, this.state.size),
                                        pagination: false,
                                        next: '',
                                        previous: '',
                                        tableLoading: false,
                                        MaxLimitModal: false,
                                        paginationState: { page: this.state.page, totalRows: this.state.totalRows, maxPage: this.state.maxPage, sort: this.state.sort, search: this.state.search, size: this.state.PageSize > 0 ? this.state.PageSize : 10 }
                                    });
                                }
                            }

                            if (this.state.page === 1) {
                                let totalRows;

                                /* checks whether to set total no. of rows */
                                if (response.data.hasOwnProperty('page')) {
                                    if (response.data['page'].hasOwnProperty('total')) {
                                        totalRows = response.data['page']['total'];
                                    }
                                } else {
                                    totalRows = response.data['data'].length
                                }

                                /* total can be zero so checking its undefined or not */
                                if (totalRows !== undefined) {
                                    this.setState({
                                        totalRows: totalRows,
                                    }, () => {
                                        this.setState({
                                            maxPage: Math.ceil(this.state.totalRows / this.state.size)
                                        }, () => {
                                            this.setState({
                                                paginationState: {
                                                    ...this.state.paginationState,
                                                    maxPage: this.state.maxPage
                                                }
                                            });
                                        });
                                    });
                                }
                                emitData['Total'] = totalRows;
                            }
                            emitData['stateData'] = this.getTableState();
                            emitData['stateData']['totalRows'] = emitData['Total'] || this.state.totalRows;
                            this.props.onDataUpdate(emitData);
                            this.forceUpdate()
                        })
                        .catch((error) => {
                            if (error.response?.status === 401) {
                                this.props.onDataUpdateStatus({
                                    error: true,
                                    status: error.response.status,
                                    errorType: 'noData'
                                });
                            }
                            this.setState({ tableLoading: false });
                            toast.error(error);
                        });
                }
            }
            else {
                this.allRows = this.props.mockData;
                this.setState({
                    rows: this.allRows,
                    pagination: false,
                    next: '',
                    previous: '',
                    tableLoading: false
                });
                if (this.state.page === 1) {
                    let totalRows;
                    totalRows = this.props.mockData.length

                    /* total can be zero so checking its undefined or not */
                    if (totalRows !== undefined) {
                        this.setState({
                            totalRows: totalRows,
                        }, () => {
                            this.setState({
                                maxPage: Math.ceil(this.state.totalRows / this.state.size),
                            });
                        });
                    }
                }
            }
        }
    };

    setPage(offset) {
        this.setState({ accordion: { display: this.state.accordion.display, rowId: -1 } })
        if (!this.state.tableLoading) {
            if (offset === -1) {
                if (this.state.page !== 1) {
                    this.setState({
                        page: this.state.page - 1
                    }, () => {
                        this.setData(offset);
                    });
                }
            } else {
                if (this.state.page + 1 <= this.state.maxPage) {
                    this.setState({
                        page: this.state.page + 1
                    }, () => {
                        this.setData(offset);
                    });
                }
            }
        }
    };

    setData = (offset) => {
        if (this.state.pagination) {
            this.getTableData(offset);
        } else {
            this.setState({
                rows: this.allRows.slice((this.state.page - 1) * this.state.size, this.state.page * this.state.size)
            });
        }
    };

    sort = (field) => {
        const sort = this.state.sort.find(element => element['field'] === field);

        if (!sort) {
            return 'fa-exchange-alt unsort-90 text-white';
        } else if (sort['direction'] === 'asc') {
            return 'fa-long-arrow-alt-up text-secondary';
        } else {
            return 'fa-long-arrow-alt-down text-secondary';
        }
    };

    updateSort = (column, defaultDirection = null) => {
        if (column['name']) {
            let direction = '';
            if (this.state.sort[0]['field'] === column['property'] && this.state.sort[0]['direction'] === 'asc') {
                direction = 'desc';
            } else {
                direction = 'asc';
            }

            this.setState({
                sort: [{ field: column['property'], direction: defaultDirection ? defaultDirection : direction }],
                page: 1,
                next: null,
                previous: null
            });

            setTimeout(() => {
                if (!this.props.isMock) {
                    this.getTableData();
                } else {
                    let sortData = [...this.allRows];

                    if (column['sortType']) {
                        sortData = this.sortType(column, [...sortData]);
                    } else {
                        this.state.sort.forEach(element => {
                            if (element['direction'] === 'asc') {
                                sortData.sort((a, b) => a[element['field']].toLowerCase() < b[element['field']].toLowerCase() ? -1 :
                                    a[element['field']].toLowerCase() > b[element['field']].toLowerCase() ? 1 : 0);
                            } else {
                                sortData.sort((a, b) => a[element['field']].toLowerCase() < b[element['field']].toLowerCase() ? 1 :
                                    a[element['field']].toLowerCase() > b[element['field']].toLowerCase() ? -1 : 0);
                            }
                        });
                    }

                    this.setState({ rows: sortData });
                }
            });
        }
    };

    sortType = (column, rowData) => {
        if (column['sortType'] === 'custom') {
            rowData = column['customSort']([...rowData]);
        } else if (column['sortType'] === 'num') {
            this.state.sort.forEach(element => {
                if (element['direction'] === 'asc') {
                    rowData.sort((a, b) => a[element['field']] < b[element['field']] ? -1 :
                        a[element['field']] > b[element['field']] ? 1 : 0);
                } else {
                    rowData.sort((a, b) => a[element['field']] < b[element['field']] ? 1 :
                        a[element['field']] > b[element['field']] ? -1 : 0);
                }
            });
        } else if (column['sortType'] === 'num-rev') {
            this.state.sort.forEach(element => {
                if (element['direction'] === 'desc') {
                    rowData.sort((a, b) => a[element['field']] < b[element['field']] ? -1 :
                        a[element['field']] > b[element['field']] ? 1 : 0);
                } else {
                    rowData.sort((a, b) => a[element['field']] < b[element['field']] ? 1 :
                        a[element['field']] > b[element['field']] ? -1 : 0);
                }
            });
        }

        return rowData;
    };

    isElipsisActive = (event, index) => {
        let element = event.target;
        if (element.offsetWidth < element.scrollWidth && element.textContent) {
            this.setState({ showTooltip: true, tooltipText: element.textContent });
            this.tooltipTextIndex = index;
        }
        else if (element.offsetWidth >= element.scrollWidth) {
            this.setState({ showTooltip: false, tooltipText: '' });
        }
    }

    navigateToCreate = () => {
        if (!isTokenExpiredBeforeOneHour(REFRESH_TOKEN)) {
            let stateData = this.props.config.search ? this.props.config.search : {};
            stateData['createSearch'] = true;
            this.props.history.push({ pathname: this.props.config.createurl, state: stateData })
        } else {
            if (getToken(REFRESH_TOKEN)) {
                store.dispatch({ type: 'TOGGLE_SESSION_MODAL', payload: true });
            }
        }
    }

    changeSize = (value) => {
        this.setState({
            search: this.state.search,
            searchData: this.state.searchData,
            page: 1,
            next: null,
            previous: null,
            sort: this.state.sort,
            accordion: { ...this.state.accordion, rowId: -1 },
            size: value,
            PageSize: value
        }, () => this.getTableData(null));
    }

    getRowsSize = () => {
        return this.state.rows.length > 0 ? this.state.size === this.state.rows.length ? this.state.size : this.state.rows.length : 10;
    }

    render() {
        return (
            <div className="w-100">
                {this.state.searchData ?
                    <div className="w-100">
                        <div className="scroll w-100 border border-outline" style={{ overflowX: this.state.showTooltip ? 'hidden' : 'auto', position: 'relative', overflowY: 'hidden', }}>
                            <table className="table-box">
                                <thead className="table-head">
                                    <tr className="row-height">
                                        {
                                            this.props.config.columns.map((column, colIdx) =>
                                                // ${column['columnType'] === 'actions' ? 'action-cell' : ''}
                                                <th key={colIdx} className={`px-2 ${column['sort'] ? 'header-cell' : ''}`}
                                                    style={{ minWidth: column['width'], width: column['width'], color: 'white', fontWeight: 'normal' }}
                                                    onClick={() => column['sort'] ? this.updateSort(column) : null}>
                                                    {column['customHeader'] ? column['customHeader'] === 'selectAll' ? this.selectAllCheckBoxsale() : column['customHeader'] === 'CSV' ? this.exportCSV() : column['customHeader'] : column['name']}
                                                    {
                                                        column['sort'] ?
                                                            <i className={`fa ${this.sort(column['property'])}`} style={{ margin: '0 4px' }}></i> :
                                                            null
                                                    }
                                                    {
                                                        column['toolTip'] ?
                                                            <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: column['toolTip'] ? 'visible' : 'hidden' }}>{column['toolTipText']}</Tooltip>}>
                                                                <i className={`fa fa-question-circle`} style={{ margin: '0 6px' }}></i>
                                                            </OverlayTrigger> : null

                                                    }

                                                </th>
                                            )
                                        }
                                    </tr>
                                </thead>
                                <tbody className="table-body">
                                    {
                                        this.state.rows.length ?
                                            [...Array(this.getRowsSize()).keys()].map((index) =>
                                                (!(("conditionKey" in this.props.config) && (this.props.config.conditionKey.length > 0) && ((typeof this.state.rows[index] === "object") && (this.state.rows[index][this.props.config.conditionKey[0]] === this.props.config.conditionKey[1])))) && [
                                                    <tr key={index} className={`row-height ${!this.props.config.ignoreRowBackground && !this.state.accordion.display && index % 2 === 0 ? 'row-bg-odd' : 'row-bg-even'} ${this.state.accordion.display && this.state.rows[index] ? 'row-border clickable' : 'row-border'}`}
                                                        onClick={this.state.accordion.display && this.state.rows[index] ? (event) => this.toggleAccordion(index, event) : null}>
                                                        {
                                                            this.props.config.columns.map((column, colIdx) =>
                                                                // className={`${column['columnType'] === 'actions' ? 'action-cell' : ''}`}
                                                                <td key={colIdx} style={{ maxWidth: column['maxWidth'] ? column['maxWidth'] : "300px", width: column['width'], padding: "7px" }} className={`${column.class ? column.class : ''}`}>
                                                                    <OverlayTrigger overlay={<Tooltip id="tableRef" style={{ visibility: this.state.showTooltip ? 'visible' : 'hidden' }}>{this.state.tooltipText}</Tooltip>} target={this.tableDataRef.current} show={this.state.showTooltip && this.columnType(this.state.rows[index], column, index) === this.state.tooltipText && index === this.tooltipTextIndex} placement="top">
                                                                        <div className="textWrap" ref={this.tableDataRef} onMouseMove={(event) => { this.setState({ showTooltip: false, tooltipText: '' }); this.isElipsisActive(event, index) }} >{this.columnType(this.state.rows[index], column, index)}</div>
                                                                    </OverlayTrigger>
                                                                </td>
                                                            )
                                                        }
                                                    </tr>,
                                                    this.state.accordion.display && this.state.accordion.rowId === index ?
                                                        <tr key={`1${index}`} className="row-bg-accordion row-border">
                                                            <td colSpan={this.props.config.columns.length}>
                                                                {this.props.config.columns[this.props.config.columns.length - 1]['accordion'](this.state.rows[index])}
                                                            </td>
                                                        </tr> :
                                                        null
                                                ]
                                            ) :
                                            <tr style={{ height: '500px' }}>
                                                <td colSpan={this.props.config.columns.length}>
                                                    <div className="d-flex align-items-center justify-content-center" style={{ width: '100%', height: '100%' }}>{this.state.tableLoading ? '' : 'No results found, please try your search again'}</div>
                                                </td>
                                            </tr>
                                    }
                                </tbody>
                            </table>
                            {
                                this.state.tableLoading ?
                                    <div className="d-flex align-items-center justify-content-center page-loader">
                                        <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" />
                                    </div> :
                                    null
                            }
                        </div>
                        {this.state.rows.length ?
                            <div className="flex-column flex-sm-row align-items-center justify-content-sm-between py-4 table-pagination" style={{ width: '100%', marginBottom: "30px" }}>
                                {this.props.config.name !== 'admin report' && this.props.config.name !== 'seller report' ?
                                    <div className="bottom-align">Showing <b>{this.state.totalRows > this.state.page * this.state.size ? `${((this.state.page - 1) * this.state.size) + 1} - ${this.state.page * this.state.size}` : this.state.page === 1 ? this.state.totalRows : `${((this.state.page - 1) * this.state.size) + 1} - ${this.state.totalRows}`}</b> of <b>{this.state.totalRows}</b> records</div>
                                    : ''}
                                <span className="custom-align-middle paginationMargin" style={{ width: this.state.extraButton ? "95%" : "95%", marginTop: '-20px', justifyContent: this.state.extraButton ? "flex-end" : "flex-end" }}>
                                    {this.state.extraButton ?
                                        this.state.extraButton()
                                        : null
                                    }
                                    <div className="m-3 m-sm-0" style={{ cursor: 'default', border: '1px solid #0000004a' }}>
                                        <i className={`fa fa-angle-double-left page-switch ${!this.state.tableLoading && this.state.page !== 1 ? 'switch-enable' : 'switch-disable'}`} onClick={() => this.setPage(-1)} />
                                        <span style={{ borderLeft: '1px solid #0000004a', borderRight: '1px solid #0000004a', padding: '4px 12px' }}>Page {this.state.page}</span>
                                        <i className={`fa fa-angle-double-right page-switch ${!this.state.tableLoading && this.state.page !== this.state.maxPage ? 'switch-enable' : 'switch-disable'}`} onClick={() => this.setPage(1)} />
                                    </div>
                                </span>
                            </div> :
                            null

                        }
                        <Modal centered show={this.state.modal} id="max-length" onHide={() => { this.setState({ ...this.state }) }} >
                            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                <Button style={{ fontSize: "23px", color: "#9d9d9d", fontWeight: "bold" }} onClick={() => {
                                    this.setState({ modal: false })
                                }} variant="">X</Button>
                            </div>
                            <Modal.Body style={{ marginBottom: "23px" }}>
                                <h5 style={{ color: "#7e7e7e", fontWeight: "bolder", fontSize: "20px", padding: "2%", textAlign: "center" }}>Maximum record download limit reached please apply filter and try again</h5>
                            </Modal.Body>
                        </Modal>
                    </div>
                    :
                    <div>
                           {
                            this.createButton.includes(this.props.config.name) ?
                                <Link to={{ pathname: this.props.config.createurl }}>
                                    <div className="d-flex justify-content">
                                        <Button className="save-button" style={{ marginLeft: "2%" }} onClick={() => this.navigateToCreate()}>+ Create</Button>
                                    </div>
                                </Link>
                                : ''
                        }
                        <div className="d-flex justify-content-center align-items-center" style={{ height: "54vh" }}>
                            <h5>{`Provide criteria to filter your search `}</h5>
                        </div>
                    </div>
                }
            </div>

        );
    }
}